export default [{
  name: 'news',
  path: '/news',
  meta: {
    layout: 'LegacyLayoutFluid'
  },
  component: require('@/pages/news/News.vue').default
}]
